export default {
  analyticsRow1: '使用AI、实时事件处理和图形数据库架构，杰为平台能够把握趋势，识别模式，分析数字化链中数据流的依赖性。基于以上信息，杰为平台可以有效改进运维进程、产品质量、整体设备效率、供应链优化等。直白的复杂关联性赋能更大程度的优化，如了解设计变更对质量和多个供应商的影响，能够更加轻松应对生产需求变更时的调整。'
}
